import { render, staticRenderFns } from "./PlacesDialog.vue?vue&type=template&id=1a06544c&scoped=true&"
import script from "./PlacesDialog.vue?vue&type=script&lang=js&"
export * from "./PlacesDialog.vue?vue&type=script&lang=js&"
import style0 from "./PlacesDialog.vue?vue&type=style&index=0&id=1a06544c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a06544c",
  null
  
)

component.options.__file = "PlacesDialog.vue"
export default component.exports